module.exports = __webpack_public_path__ + "static/media/AR.e405cf16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/components/CoinCircle/icons/AR.svg
// module id = 1501
// module chunks = 83